module.exports = __webpack_public_path__ + "static/feature-2-17609d6e0e02e14c863974078838545c.svg";